import React, { useEffect, useState } from "react";
import NextHead from "next/head";
import NextApp from "next/app";
import { Provider } from "react-intl-redux";
import getConfig from "next/config";
import { useRouter } from "next/router";
import NextNProgress from "nextjs-progressbar";
import NProgress from "nprogress";
import Layout from "./components/layout/layout";
import {
  ssoLogin,
  catchRefererKey,
  checkAndRefreshToken,
  logoutSession,
} from "@tw/customer-identity-cra/lib/common/utils/login";
import { getAcApiUrl } from "@tw/shared-ui-components/lib/utils/helper"
import getOrCreateStore from "../redux/get-or-create-store";
import "./components/css/app.css";
import { PROTECTED_REGEX_ROUTES } from "../utils/Constants/Data";
import {
  getUserInfoFromCookie,
  redirectToLogin,
  isTokenValid,
} from "../utils/auth/helper";
import "../utils/auth/axios-interceptor";
import Tutorial from "./components/tutorial/tutorial";
function App(props) {
  const { Component, initialStateOrStore, pageProps } = props;
  const router = useRouter();

  const [routerAsPath, setRouterAsPath] = useState(null);

  const {
    layout = {},
    reduxModules: pageReduxModules = [],
    pageId,
  } = Component;
  useEffect(() => {
    checkForProtectedRoute();
    // 初始加載時手動執行一次
    handleRouteChange();
  }, [routerAsPath]);

  useEffect(() => {
    setRouterAsPath(router?.asPath);
  }, [router]);
  //  TEP-17422 處理路徑中帶 hash 的場景
  useEffect(() => {
    try {
      if (typeof window === 'undefined') return;
      // 函数：只要出现 hash 就跳 404
      const checkHash = () => {
        if (window.location.hash === '#/landing') {
          router.replace('/404');
        }
      };

      // 1. 首次载入检查
      checkHash();

      // 2. 监听真实 hash 路由改变
      window.addEventListener('hashchange', checkHash);

      // 3. 清理
      return () => {
        window.removeEventListener('hashchange', checkHash);
      };
    } catch (error) {
      console.log('checkHash >> catch error', error);
    }
  }, []);


  // TEP-17422 路由检查逻辑（保留优化，新增参数匹配调试）
  const handleRouteChange = (url) => {
    if (typeof window === 'undefined') return;

    const pathname = window.location.pathname;
    if (!pathname) return;
    // 不被允許訪問的黑名單
    const BLACK_PATHS = [
      /\/null/,
    ]
    // 去重 + 排序（具体路径在前，避免宽泛匹配优先）
    const uniqueRegexSet = new Set(BLACK_PATHS.map(re => re.toString()));
    const uniqueAllowedPaths = Array.from(uniqueRegexSet)
      .map(str => new RegExp(str.slice(1, -1)))
      .sort((a, b) => b.toString().length - a.toString().length); // 长正则（具体）优先

    // 精准匹配检查
    const isNotAllowed = uniqueAllowedPaths.some((regexRoute) => {
      const isMatch = regexRoute.test(pathname);
      if (isMatch) console.log(`✅ 路径 ${pathname} 匹配规则：${regexRoute}`);
      return isMatch;
    });

    console.log(`🔍 最终判断：${pathname} → ${isNotAllowed ? '不允许访问跳404' : '允许访问'}`);

    if (isNotAllowed) {
      router.replace('/404');
    }
  };
  const checkForProtectedRoute = () => {
    console.log("[app][checkForProtectedRoute] >> ", routerAsPath);

    const loggedInUserInfo = getUserInfoFromCookie() || {};
    const { accessToken, ada, role } = loggedInUserInfo;
    const tokenValidity = isTokenValid(accessToken);
    if (!accessToken || !ada || !role || !tokenValidity) {
      const isRoutePathProtected = PROTECTED_REGEX_ROUTES.some((regexRoute) =>
        regexRoute.test(routerAsPath)
      );

      if (isRoutePathProtected) {
        logoutSession();
        redirectToLogin("p");
      }
    }
  };

  // On SSR, `initialStateOrStore` will be the store. On the first client render, it will be the
  // initial state which will be used to create the client store. On subsequent client renders,
  // `initialStateOrStore` will be the singleton store.
  const store =
    initialStateOrStore.dispatch && initialStateOrStore.getState
      ? initialStateOrStore
      : getOrCreateStore(initialStateOrStore, pageReduxModules);

  const nextconfig = getConfig();
  if (typeof window !== "undefined") {
    window.appConfig = {
      ...nextconfig.publicRuntimeConfig,
    };
    window.useRouter = useRouter;
    window.useParams = () => useRouter().query;

    // for turn off progress filter/screen purpose.
    // Please use window.NProgress.done();
    window.NProgress = NProgress;

    // To perform ssoLogin
    ssoLogin();

    // To refresh accessToken, if refreshToken is expired,
    // it will proceed to logout and redirect to login
    checkAndRefreshToken(PROTECTED_REGEX_ROUTES);

    // To catch referrer key for shared-links
    catchRefererKey();
  }

  return (
    <React.Fragment>
      <Provider store={store}>
        {
          // switchStatus?.enabled ? <div dangerouslySetInnerHTML={{ __html: switchStatus?.content }}></div>
          //   :
          //   <Layout>
          //     <NextHead>
          //       {/* <title>安麗（台灣）網路商城</title> */}
          //       <link rel="icon" href="/favicon.ico" />
          //       <meta content="yes" name="apple-mobile-web-app-capable" />
          //       <meta
          //         name="viewport"
          //         content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
          //       />
          //     </NextHead>
          //     <Component {...pageProps} />
          //     <NextNProgress color="#38539a" />
          //     <Tutorial pageId={pageId} />
          //   </Layout>
        }
        <Layout>
          <NextHead>
            {/* <title>安麗（台灣）網路商城</title> */}
            <link rel="icon" href="/favicon.ico" />
            <meta content="yes" name="apple-mobile-web-app-capable" />
            <meta
              name="viewport"
              content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
            />
          </NextHead>
          <Component {...pageProps} />
          <NextNProgress color="#38539a" />
          <Tutorial pageId={pageId} />
        </Layout>
      </Provider>
      {/* To hide the Google reCaptcha v3 badge */}
      <style>
        {
          "\
        .grecaptcha-badge{\
          visibility: hidden;\
        }\
        "
        }
      </style>
    </React.Fragment>
  );
}

// `App.getInitialProps` is executed on the server during SSR and it is NOT executed on the first
// client render. All subsequent client renders will execute it.
App.getInitialProps = async (appContext) => {
  try {
    const { Component, ctx } = appContext;
    const { reduxModules: pageReduxModules } = Component;

    // On SSR, this will create a store. On client renders (except for the first one), this will
    // retrieve the existing store, which will then be passed through to `App`.
    ctx.store = getOrCreateStore();

    // The `toJSON` method is executed when the return value of this function is serialized by next
    // and set on the html for hydration on the client.
    ctx.store.toJSON = () => ctx.store.getState();

    // On the server, set these immediately as there's no previous modules to remove
    if (typeof window === "undefined") {
      if (pageReduxModules) {
        ctx.store.addPageModules(pageReduxModules);
      }

      // To get login info on initial req in server side
      // console.log("cookie in _app", ctx.req.headers.cookie);
      if (ctx.req?.headers?.cookie) {
        process.loggedInUserInfo = getUserInfoFromCookie(
          ctx.req?.headers?.cookie
        );
      } else {
        process.loggedInUserInfo = undefined;
      }

      // To store full route of request to be used in canonical tag for seo
      process.fullRoute = `https://${ctx.req?.headers?.host}${ctx.req?.url}`;
      process.origin = `https://${ctx.req?.headers?.host}`;
    }

    let appProps = {};
    //Bryan (20211112) - handle if the page is CSR
    if (typeof window !== "undefined" && pageReduxModules?.length > 0) {
      // 额外判断当前 store 状态是否仍需要更新
      if (pageReduxModules[0].id !== ctx?.store.currentModule) {
        if (ctx?.store?.currentModule !== pageReduxModules[0]?.id) {
          // 通過 await 確保模塊移除和添加操作按照順序完成，避免干扰 React 渲染
          await ctx?.store?.removePageModules(); // 移除當前頁面的狀態模塊
          if (pageReduxModules) {
            await ctx?.store?.addPageModules(pageReduxModules); // 添加新頁面的狀態模塊
          }
        }
      }
    }
    // const res = await fetch(`${getAcApiUrl()}/anon/getMaintenanceStatus`, {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/json'
    //   }
    // })
    // const posts = await res?.json()
    try {
      appProps = await NextApp.getInitialProps(appContext);
    } catch (error) {
      console.log("_app.js: error", error);
    }
    return {
      // switchStatus: posts,
      ...appProps,
      initialStateOrStore: ctx.store,
    };
  } catch (error) {
    console.log("[app][getInitialProps] >> ", error);
  }
};

export default App;
